// SEO copy for the /tags index page: title, meta description, h1 and the
// intro paragraph, filled from the site's real tag and scene counts.

// What each site's scenes are, for the /tags copy ("across 1,100+ petite girl
// scenes"). Keyed by the site's host. A site that isn't listed has no niche,
// and the copy reads without one ("across 1,100+ scenes").
export const SITE_NICHES = {
  "passion-hd.com": "sensual hardcore",
  "anal4k.com": "anal",
  "bbcpie.com": "interracial creampie",
  "castingcouch-x.com": "amateur casting",
  "cum4k.com": "creampie",
  "exotic4k.com": "exotic model",
  "facials4k.com": "facial cumshot",
  "girlcum.com": "female orgasm",
  "holed.com": "anal",
  "lubed.com": "oiled-up",
  "pornplus.com": "hardcore",
  "pornpros.com": "hardcore",
  "puremature.com": "MILF",
  "spyfam.com": "step family",
  "strippers4k.com": "stripper",
  "tiny4k.com": "petite girl",
  "wetvr.com": "virtual reality",
}

// Every site films in the same format.
export const SITE_FORMAT = "4K HD"

export const siteNiche = (host) =>
  SITE_NICHES[(host ?? "").toLowerCase().replace(/^www\./, "")] ?? ""

// 1,187 → "1,100"; 57 → "57". The copy adds the "+".
export const formatSceneCount = (count) => {
  const n = Math.max(0, Math.floor(Number(count) || 0))
  const shown = n >= 100 ? Math.floor(n / 100) * 100 : n
  return shown.toLocaleString("en-US")
}

// ["a"] → "a"; ["a", "b"] → "a and b"; ["a", "b", "c"] → "a, b and c".
export const joinList = (items) =>
  items.length <= 2
    ? items.join(" and ")
    : `${items.slice(0, -1).join(", ")} and ${items.at(-1)}`

// The largest tags first (ties A–Z), as lowercase labels for prose.
export const topTagNames = (tags, count) =>
  [...tags]
    .sort(
      (a, b) => b.sceneCount - a.sceneCount || a.label.localeCompare(b.label),
    )
    .slice(0, count)
    .map((tag) => tag.label.toLowerCase())

// `tags` are the tags the page lists; `totalScenes` the site's public scene
// count, or null when the API didn't send one (the clause is then left out).
// With no tags there is nothing to describe, so the description and intro
// fall back to a plain line and no paragraph.
export const tagsIndexCopy = ({
  brand,
  niche = "",
  tags = [],
  totalScenes,
}) => {
  const tagCount = tags.length
  const nicheWord = niche ? `${niche} ` : ""
  const heading = `${brand} Porn Categories and Tags`

  if (!tagCount) {
    return {
      title: `${brand} Porn Categories | ${brand}`,
      description: `Every ${brand} category in one place. New videos every week.`,
      heading,
      intro: "",
    }
  }

  const tagsWord = tagCount === 1 ? "tag" : "tags"
  const title = `${brand} Porn Categories – Browse ${tagCount.toLocaleString("en-US")} ${tagCount === 1 ? "Tag" : "Tags"} | ${brand}`

  const scenes =
    totalScenes == null
      ? ""
      : ` across ${formatSceneCount(totalScenes)}+ ${nicheWord}scenes in ${SITE_FORMAT}`
  const descriptionTags = topTagNames(tags, 3)
  const description =
    `Every ${brand} category in one place. ` +
    `Browse ${tagCount.toLocaleString("en-US")} ${tagsWord}${scenes}, ` +
    `from ${descriptionTags.join(", ")} and more. New videos every week.`

  const introTags = topTagNames(tags, 5)
  const biggest =
    introTags.length === 1
      ? `The biggest category right now is ${introTags[0]}`
      : `The biggest categories right now are ${joinList(introTags)}`
  const intro =
    `Every scene on ${brand} is tagged by what happens in it, so you can get straight to what you came for. ` +
    `Pick a tag below to see all the ${nicheWord}videos in that category, newest first, each one filmed in ${SITE_FORMAT}. ` +
    `${biggest}; tags with more videos appear first, and the count next to each one tells you how many scenes are inside. ` +
    `We add new scenes every week and tag them the day they go live, so the numbers keep growing.`

  return { title, description, heading, intro }
}
